<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 1080 1920"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xml:space="preserve"
    xmlns:serif="http://www.serif.com/"
    style="fill-rule: evenodd; clip-rule: evenodd; stroke-miterlimit: 10"
  >
    <g id="Animate" transform="matrix(0.492799,0,0,0.5,0,0)">
      <g transform="matrix(1.01461,0,0,1,0,0)">
        <rect
          x="0"
          y="0"
          width="2160"
          height="3840"
          style="fill: rgb(255, 236, 251)"
        />
      </g>
      <g class="golven1">
        <g class="swing">
          <g>
            <g transform="matrix(1,0,0,1,1970.56,3534.62)">
              <path
                d="M0,-1570L-1189,-1236L-1809,-108L-722,0L-300,-883L0,-1570Z"
                style="
                  fill: none;
                  fill-rule: nonzero;
                  stroke: rgb(255, 211, 252);
                  stroke-width: 30px;
                "
              />
            </g>
            <g
              transform="matrix(-0.708811,0.705399,0.705399,0.708811,1428.76,2118.56)"
            >
              <path
                d="M-562.648,-1183.74L609.738,-1183.74L585.755,-328.901L-994.114,-544.139L-562.648,-1183.74Z"
                style="
                  fill: none;
                  fill-rule: nonzero;
                  stroke: rgb(255, 211, 252);
                  stroke-width: 5px;
                "
              />
            </g>
            <g transform="matrix(1,0,0,1,1248.56,2298.62)">
              <path
                d="M0,1236L540,1090L-467,0L0,1236Z"
                style="
                  fill: none;
                  fill-rule: nonzero;
                  stroke: rgb(255, 211, 252);
                  stroke-width: 11px;
                "
              />
            </g>
            <g
              transform="matrix(-0.251063,-0.967971,-0.967971,0.251063,888.862,2048.14)"
            >
              <path
                d="M-215.518,166.75L129.018,166.75"
                style="
                  fill: none;
                  fill-rule: nonzero;
                  stroke: rgb(255, 211, 252);
                  stroke-width: 3px;
                "
              />
            </g>
          </g>
          <g id="Bol6" transform="matrix(0,-1,-1,0,1248.56,3388.62)">
            <path
              d="M-146,-146C-226.634,-146 -292,-80.634 -292,0C-292,80.634 -226.634,146 -146,146C-65.366,146 0,80.634 0,0C0,-80.634 -65.366,-146 -146,-146"
              style="fill: rgb(255, 211, 252); fill-rule: nonzero"
            />
          </g>
          <g id="Bol5" transform="matrix(0,-1,-1,0,161.562,1644.62)">
            <path
              d="M-65,-65C-100.899,-65 -130,-35.898 -130,0C-130,35.899 -100.899,65 -65,65C-29.102,65 0,35.899 0,0C0,-35.898 -29.102,-65 -65,-65"
              style="fill: rgb(255, 211, 252); fill-rule: nonzero"
            />
          </g>
          <g
            id="BolDNA"
            transform="matrix(1,0,0,1,-82.6685,0)"
            class="heartbeat"
          >
            <g transform="matrix(0,-1,-1,0,278,3148.62)">
              <path
                d="M-278,-278C-431.535,-278 -556,-153.535 -556,0C-556,153.535 -431.535,278 -278,278C-124.465,278 0,153.535 0,0C0,-153.535 -124.465,-278 -278,-278"
                style="fill: rgb(255, 211, 252); fill-rule: nonzero"
              />
            </g>
            <g transform="matrix(1,0,0,1,228.853,3342.93)">
              <path
                d="M0,151.565L98.517,151.565C97.074,147.595 95.495,143.851 93.781,140.333C92.067,136.814 90.037,133.341 87.691,129.913L10.826,129.913C8.48,133.341 6.451,136.769 4.736,140.198C3.022,143.626 1.443,147.415 0,151.565M28.96,108.261L69.558,108.261C66.49,105.193 63.242,102.126 59.814,99.058C56.386,95.991 52.867,92.924 49.259,89.856C45.65,92.924 42.131,95.991 38.703,99.058C35.275,102.126 32.027,105.193 28.96,108.261M49.259,61.709C52.867,58.641 56.386,55.574 59.814,52.506C63.242,49.439 66.49,46.372 69.558,43.304L28.96,43.304C32.027,46.372 35.275,49.439 38.703,52.506C42.131,55.574 45.65,58.641 49.259,61.709M10.826,21.652L87.691,21.652C90.037,18.224 92.067,14.796 93.781,11.367C95.495,7.939 97.074,4.15 98.517,0L0,0C1.443,3.969 3.022,7.713 4.736,11.232C6.451,14.75 8.48,18.224 10.826,21.652M-26.524,194.869L-26.524,184.043C-26.524,158.963 -21.291,138.619 -10.826,123.011C-0.361,107.404 14.074,91.661 32.478,75.782C14.074,59.904 -0.361,44.161 -10.826,28.554C-21.291,12.946 -26.524,-7.398 -26.524,-32.478L-26.524,-43.304L-4.872,-43.304L-4.872,-32.478C-4.872,-30.494 -4.827,-28.644 -4.736,-26.93C-4.646,-25.216 -4.511,-23.457 -4.33,-21.652L102.848,-21.652C103.028,-23.457 103.164,-25.216 103.254,-26.93C103.344,-28.644 103.389,-30.494 103.389,-32.478L103.389,-43.304L125.041,-43.304L125.041,-32.478C125.041,-7.398 119.809,12.946 109.343,28.554C98.878,44.161 84.443,59.904 66.039,75.782C84.443,91.661 98.878,107.404 109.343,123.011C119.809,138.619 125.041,158.963 125.041,184.043L125.041,194.869L103.389,194.869L103.389,184.043C103.389,182.058 103.344,180.209 103.254,178.495C103.164,176.781 103.028,175.021 102.848,173.217L-4.33,173.217C-4.511,175.021 -4.646,176.781 -4.736,178.495C-4.827,180.209 -4.872,182.058 -4.872,184.043L-4.872,194.869L-26.524,194.869Z"
                style="fill: rgb(255, 236, 251); fill-rule: nonzero"
              />
            </g>
          </g>
          <g id="bol4" transform="matrix(0,-1,-1,0,992.562,817.622)">
            <path
              d="M-65,-65C-100.899,-65 -130,-35.899 -130,0C-130,35.898 -100.899,65 -65,65C-29.102,65 0,35.898 0,0C0,-35.899 -29.102,-65 -65,-65"
              style="fill: rgb(255, 211, 252); fill-rule: nonzero"
            />
          </g>
          <g id="bol3" transform="matrix(0,-1,-1,0,1788.56,3323.62)">
            <path
              d="M-65,-65C-100.898,-65 -130,-35.899 -130,0C-130,35.899 -100.898,65 -65,65C-29.101,65 0,35.899 0,0C0,-35.899 -29.101,-65 -65,-65"
              style="fill: rgb(255, 211, 252); fill-rule: nonzero"
            />
          </g>
          <g id="BolMicroscoop" class="heartbeat">
            <g transform="matrix(0,-1,-1,0,1970.56,1743.62)">
              <path
                d="M-221,-221C-343.055,-221 -442,-122.055 -442,0C-442,122.055 -343.055,221 -221,221C-98.945,221 0,122.055 0,0C0,-122.055 -98.945,-221 -221,-221"
                style="fill: rgb(255, 211, 252); fill-rule: nonzero"
              />
            </g>
            <g transform="matrix(1,0,0,1,1957.56,1997.73)">
              <path
                d="M0,-67.962C3.851,-67.962 7.079,-69.265 9.685,-71.87C12.29,-74.475 13.593,-77.703 13.593,-81.555C13.593,-85.406 12.29,-88.634 9.685,-91.239C7.079,-93.844 3.851,-95.147 0,-95.147C-3.851,-95.147 -7.079,-93.844 -9.685,-91.239C-12.29,-88.634 -13.593,-85.406 -13.593,-81.555C-13.593,-77.703 -12.29,-74.475 -9.685,-71.87C-7.079,-69.265 -3.851,-67.962 0,-67.962M42.817,-60.486L55.05,-65.243L31.943,-129.128L19.03,-124.371L42.817,-60.486ZM-74.759,95.148L-74.759,67.963L-6.796,67.963L-6.796,40.778C-25.599,40.778 -41.627,34.152 -54.88,20.899C-68.133,7.646 -74.759,-8.381 -74.759,-27.184C-74.759,-41.004 -70.964,-53.577 -63.375,-64.904C-55.786,-76.231 -45.535,-84.5 -32.622,-89.71C-30.81,-97.413 -26.789,-103.642 -20.559,-108.4C-14.329,-113.157 -7.249,-115.536 0.68,-115.536L-6.796,-136.604L6.117,-141.362L1.359,-153.595L27.185,-163.11L31.263,-150.197L44.176,-154.954L81.555,-53.01L68.642,-48.253L73.4,-35.34L47.574,-25.825L43.496,-38.738L30.583,-33.981L22.428,-56.408C19.03,-53.237 15.122,-50.858 10.704,-49.272C6.287,-47.686 1.812,-47.12 -2.719,-47.573C-7.702,-48.026 -12.347,-49.556 -16.651,-52.161C-20.955,-54.766 -24.693,-57.994 -27.865,-61.845C-33.981,-58.221 -38.795,-53.35 -42.307,-47.233C-45.818,-41.117 -47.574,-34.434 -47.574,-27.184C-47.574,-15.857 -43.609,-6.229 -35.68,1.7C-27.751,9.629 -18.123,13.593 -6.796,13.593L101.944,13.593L101.944,40.778L33.981,40.778L33.981,67.963L115.536,67.963L115.536,95.148L-74.759,95.148Z"
                style="fill: rgb(255, 236, 251); fill-rule: nonzero"
              />
            </g>
          </g>
          <g id="BolReageerbuis" class="heartbeat">
            <g transform="matrix(0,-1,-1,0,781.562,2152.62)">
              <path
                d="M-146,-146C-226.634,-146 -292,-80.634 -292,0C-292,80.634 -226.634,146 -146,146C-65.366,146 0,80.634 0,0C0,-80.634 -65.366,-146 -146,-146"
                style="fill: rgb(255, 211, 252); fill-rule: nonzero"
              />
            </g>
            <g transform="matrix(1,0,0,1,740.275,2363.03)">
              <path
                d="M0,-95.636L0,-111.575L0,-95.636ZM39.848,15.939C46.49,15.939 52.135,13.615 56.784,8.966C61.433,4.317 63.757,-1.328 63.757,-7.97L39.848,-7.97L39.848,-23.909L63.757,-23.909L63.757,-39.848L39.848,-39.848L39.848,-55.788L63.757,-55.788L63.757,-79.697L15.939,-79.697L15.939,-7.97C15.939,-1.328 18.264,4.317 22.913,8.966C27.562,13.615 33.207,15.939 39.848,15.939M0,-95.636L79.697,-95.636L79.697,-111.575L0,-111.575L0,-95.636ZM39.848,31.879C28.824,31.879 19.426,27.993 11.656,20.223C3.885,12.453 0,3.055 0,-7.97L0,-79.697C-4.383,-79.697 -8.136,-81.257 -11.257,-84.379C-14.379,-87.5 -15.939,-91.253 -15.939,-95.636L-15.939,-111.575C-15.939,-115.959 -14.379,-119.711 -11.257,-122.832C-8.136,-125.954 -4.383,-127.515 0,-127.515L79.697,-127.515C84.08,-127.515 87.832,-125.954 90.954,-122.832C94.075,-119.711 95.636,-115.959 95.636,-111.575L95.636,-95.636C95.636,-91.253 94.075,-87.5 90.954,-84.379C87.832,-81.257 84.08,-79.697 79.697,-79.697L79.697,-7.97C79.697,3.055 75.811,12.453 68.041,20.223C60.271,27.993 50.873,31.879 39.848,31.879"
                style="fill: rgb(255, 236, 251); fill-rule: nonzero"
              />
            </g>
          </g>
          <g id="bol2" transform="matrix(0,-1,-1,0,1670.56,2519.62)">
            <path
              d="M-132,-132C-204.901,-132 -264,-72.902 -264,0C-264,72.902 -204.901,132 -132,132C-59.098,132 0,72.902 0,0C0,-72.902 -59.098,-132 -132,-132"
              style="fill: rgb(255, 211, 252); fill-rule: nonzero"
            />
          </g>
          <g id="Bol1" transform="matrix(0,-1,-1,0,1749.56,966.622)">
            <path
              d="M-65,-65C-100.899,-65 -130,-35.899 -130,0C-130,35.899 -100.899,65 -65,65C-29.102,65 0,35.899 0,0C0,-35.899 -29.102,-65 -65,-65"
              style="fill: rgb(255, 211, 252); fill-rule: nonzero"
            />
          </g>
          <g id="Bolklein" transform="matrix(0,-1,-1,0,695.062,1941.12)">
            <path
              d="M-24,-24C-37.255,-24 -48,-13.255 -48,0C-48,13.255 -37.255,24 -24,24C-10.745,24 0,13.255 0,0C0,-13.255 -10.745,-24 -24,-24"
              style="fill: rgb(255, 211, 252); fill-rule: nonzero"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "BackgroundAnimation",
};
</script>

<style scoped></style>
